<script setup>
import { onMounted, onUnmounted } from 'vue';
import {
  createSidebarContext,
  SIDEBAR_WIDTH,
  SIDEBAR_WIDTH_ICON,
  SIDEBAR_KEYBOARD_SHORTCUT,
} from 'dashboard/composables/useSidebar';

const props = defineProps({
  defaultOpen: { type: Boolean, default: true },
  open: { type: Boolean, default: undefined },
});

const emit = defineEmits(['update:open']);

const context = createSidebarContext({
  defaultOpen: props.defaultOpen,
  open: props.open,
  onOpenChange: value => emit('update:open', value),
});

// Raccourci clavier pour toggle
const handleKeyDown = event => {
  if (
    event.key === SIDEBAR_KEYBOARD_SHORTCUT &&
    (event.metaKey || event.ctrlKey)
  ) {
    event.preventDefault();
    context.toggleSidebar();
  }
};

onMounted(() => {
  if (typeof window !== 'undefined') {
    window.addEventListener('keydown', handleKeyDown);
  }
});

onUnmounted(() => {
  if (typeof window !== 'undefined') {
    window.removeEventListener('keydown', handleKeyDown);
  }
});
</script>

<template>
  <div
    class="group/sidebar-wrapper flex min-h-svh w-full has-[[data-variant=inset]]:bg-sidebar"
    :style="{
      '--sidebar-width': SIDEBAR_WIDTH,
      '--sidebar-width-icon': SIDEBAR_WIDTH_ICON,
    }"
  >
    <slot />
  </div>
</template>
